import { Box, Container, Link, Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useState } from "react";
// import { styled } from "@mui/material/styles";
// import AdbIcon from "@mui/icons-material/Adb";
// import { Facebook, Instagram, LinkedIn, Twitter } from "@mui/icons-material";

// const LinkRoot = styled(Link)(({ theme }) => ({
//   display: "block",
//   color: "#ddd",
//   textDecoration: "none",
//   "&:hover": {
//     color: "#fff",
//   },
// }));

// const IconButtonRoot = styled(IconButton)(() => ({
//   color: "#ddd",
//   "&:hover": {
//     color: "#fff",
//   },
// }));

function Footer() {
  const [openOffice, setOpenOffice] = useState(false);
  return (
    <div>
      <div className="bg-[#53565a]">
        <Container sx={{ maxWidth: { lg: 1024, xl: 1280 }, py: 16 }}>
          <Stack
            direction={{ xs: "column", md: "row" }}
            gap={{ xs: 14, md: 1 }}
            mx="auto"
            width="100%"
          >
            <Stack
              gap={5}
              width={{ xs: "100%", md: "50%" }}
              position="relative"
            >
              <Typography color="white">Contact Us</Typography>
              <Typography color="white">
                We value your inquiries, feedback, and collaboration
                opportunities. Our dedicated team is ready to assist you. Feel
                free to reach out for any questions or information regarding our
                services, products, or partnerships.
              </Typography>
              <Typography color="white">
                10th Floor, Flexi-Space, Mechelsesteenweg 455, 1950 Kraainem,
                Belgium{" "}
                <Link
                  href="tel:+32491325020"
                  color="#fff"
                  sx={{ textWrap: "nowrap" }}
                >
                  (+32) 491 32 5020
                </Link>
              </Typography>
              <Grid
                container
                columns={{ xs: 1, hs: 2 }}
                wrap="wrap"
                columnSpacing={{ xs: 0, lg: 6 }}
                width={{ xs: "100%", lg: "70%" }}
              >
                <Grid
                  size={1}
                  color="#fff"
                  textAlign={{ xs: "center", md: "left" }}
                  onClick={() => setOpenOffice(!openOffice)}
                >
                  Head Office :
                </Grid>
                <Grid
                  size={1}
                  color="#5ea1ff"
                  component="a"
                  href="mailto:info@meetfutur.com"
                  sx={{ textDecoration: "underline" }}
                  textAlign={{ xs: "center", md: "left" }}
                >
                  info@meetfutur.com
                </Grid>
                <Grid
                  size={1}
                  color="#fff"
                  textAlign={{ xs: "center", md: "left" }}
                >
                  Sales :
                </Grid>
                <Grid
                  size={1}
                  color="#5ea1ff"
                  textAlign={{ xs: "center", md: "left" }}
                  component="a"
                  href="mailto:sales@meetfutur.com"
                  sx={{ textDecoration: "underline" }}
                >
                  sales@meetfutur.com
                </Grid>
                <Grid
                  size={1}
                  color="#fff"
                  textAlign={{ xs: "center", md: "left" }}
                >
                  Customer services :
                </Grid>
                <Grid
                  size={1}
                  color="#5ea1ff"
                  textAlign={{ xs: "center", md: "left" }}
                  component="a"
                  href="mailto:service@meetfutur.com"
                  sx={{ textDecoration: "underline" }}
                >
                  services@meetfutur.com
                </Grid>
              </Grid>
              {openOffice ? (
                <Typography
                  color="white"
                  position="absolute"
                  top="calc(100% + 10px)"
                >
                  WESTCO
                  <br />
                  Unit 214, Science and Technology Park Of Kurdistan, Zakaryaye
                  Razi Blvd, Ghane Sq, Baharan, Sanandaj, Kurdistan, Iran.
                </Typography>
              ) : (
                ""
              )}
            </Stack>

            <Box
              sx={{
                width: { xs: "100%", md: "50%" },
                height: { xs: "500px", md: "auto" },
                borderRadius: 5,
                overflow: "hidden",
              }}
            >
              <iframe
                title="Google Address"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
                src="https://www.google.com/maps?q=50.820892526135836,4.476854785174556&z=15&output=embed"
              ></iframe>
            </Box>
          </Stack>
          <hr style={{ margin: "110px 0 40px 0" }} />
          <Box textAlign="center">
            <Typography variant="body2" color="white" textAlign="center">
              © 2025 MEETFUTUR all rights reserved.
            </Typography>
          </Box>
          {/* <Grid
            container
            spacing={7}
            columns={{ xs: 1, md: 6, lg: 6, xl: 4 }}
            sx={{ py: 8 }}
          >
            <Grid size={{ xs: 1, md: 6, lg: 6, xl: 1 }}>
              <div className="flex">
                <AdbIcon color="white" sx={{ display: "flex", mr: 1 }} />
                <Typography
                  variant="h6"
                  noWrap
                  component="a"
                  href="#app-bar-with-responsive-menu"
                  sx={{
                    mr: 2,
                    display: "flex",
                    fontFamily: "monospace",
                    fontWeight: 700,
                    letterSpacing: ".3rem",
                    color: "#ddd",
                    textDecoration: "none",
                  }}
                >
                  LOGO
                </Typography>
              </div>
              <IconButtonRoot color="inherit" href="#">
                <Facebook />
              </IconButtonRoot>
              <IconButtonRoot color="inherit" href="#">
                <Twitter />
              </IconButtonRoot>
              <IconButtonRoot color="inherit" href="#">
                <Instagram />
              </IconButtonRoot>
              <IconButtonRoot color="inherit" href="#">
                <LinkedIn />
              </IconButtonRoot>
              <IconButtonRoot color="inherit" href="#">
                <LinkedIn />
              </IconButtonRoot>
              <IconButtonRoot color="inherit" href="#">
                <LinkedIn />
              </IconButtonRoot>
            </Grid>

            <Grid size={{ xs: 1, md: 2, lg: 2, xl: 1 }}>
              <Typography color="white" variant="h6" gutterBottom>
                Products and Solutions
              </Typography>
              <LinkRoot href="#">Smart Home OS</LinkRoot>
              <LinkRoot href="#">Whole Home</LinkRoot>
              <LinkRoot href="#">Climate and Comfort</LinkRoot>
              <LinkRoot href="#">Home Network</LinkRoot>
              <LinkRoot href="#">Home Security</LinkRoot>
              <LinkRoot href="#">Home Theater</LinkRoot>
              <LinkRoot href="#">Smart Home OS</LinkRoot>
              <LinkRoot href="#">Whole Home</LinkRoot>
              <LinkRoot href="#">Climate and Comfort</LinkRoot>
              <LinkRoot href="#">Home Network</LinkRoot>
              <LinkRoot href="#">Home Security</LinkRoot>
              <LinkRoot href="#">Home Theater</LinkRoot>
              <LinkRoot href="#">Smart Home OS</LinkRoot>
              <LinkRoot href="#">Whole Home</LinkRoot>
            </Grid>

            <Grid size={{ xs: 1, md: 2, lg: 2, xl: 1 }}>
              <Box sx={{ mb: 5 }}>
                <Typography color="white" variant="h6" gutterBottom>
                  Products and Solutions
                </Typography>
                <LinkRoot href="#">Smart Home OS</LinkRoot>
                <LinkRoot href="#">Whole Home</LinkRoot>
                <LinkRoot href="#">Home Security</LinkRoot>
                <LinkRoot href="#">Home Theater</LinkRoot>
              </Box>
              <Box>
                <Typography color="white" variant="h6" gutterBottom>
                  Products and Solutions
                </Typography>
                <LinkRoot href="#">Smart Home OS</LinkRoot>
                <LinkRoot href="#">Whole Home</LinkRoot>
                <LinkRoot href="#">Climate and Comfort</LinkRoot>
                <LinkRoot href="#">Home Network</LinkRoot>
                <LinkRoot href="#">Home Security</LinkRoot>
                <LinkRoot href="#">Home Security</LinkRoot>
              </Box>
            </Grid>
            <Grid size={{ xs: 1, md: 2, lg: 2, xl: 1 }}>
              <Box sx={{ mb: 5 }}>
                <Typography color="white" variant="h6" gutterBottom>
                  Products and Solutions
                </Typography>
                <LinkRoot href="#">Smart Home OS</LinkRoot>
                <LinkRoot href="#">Whole Home</LinkRoot>
              </Box>
              <Box>
                <Typography color="white" variant="h6" gutterBottom>
                  Products and Solutions
                </Typography>
                <LinkRoot href="#">Smart Home OS</LinkRoot>
                <LinkRoot href="#">Whole Home</LinkRoot>
                <LinkRoot href="#">Climate and Comfort</LinkRoot>
                <LinkRoot href="#">Home Network</LinkRoot>
                <LinkRoot href="#">Home Security</LinkRoot>
                <LinkRoot href="#">Home Security</LinkRoot>
                <LinkRoot href="#">Home Security</LinkRoot>
                <LinkRoot href="#">Home Security</LinkRoot>
              </Box>
            </Grid>
          </Grid>

          <hr />

          <Box textAlign="center" py={4}>
            <Typography variant="body2" color="gray" textAlign="left">
              © 2025 Snap One, LLC | Privacy Terms of Use Legal Report
              Vulnerability Cookies
            </Typography>
          </Box> */}
        </Container>
      </div>
    </div>
  );
}

export default Footer;
